export default __webpack_public_path__ + "static/tos-1.2.70bc.html";